import { IDistribution } from '../../../model/distributions/Distribution';
import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../../../model/RootStoreContext';
import { useParams } from 'react-router-dom';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

export interface useDistributionResult {
    isLoaded: boolean;
    distribution: IDistribution | null;
}

export const useDistribution = () => {
    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();
    const { distributionId } = useParams() as { distributionId: string };

    const [result, setResult] = useState<useDistributionResult>({ isLoaded: false, distribution: null });

    useEffect(() => {
        setResult({ isLoaded: false, distribution: null });
        rootStore.distributionStore.getDistribution(parseInt(distributionId))
            .then(distribution => {
                setResult({ isLoaded: true, distribution: distribution });
            })
            .catch(e => publishNotification({
                text: 'Error loading distribution'
            }));
    }, [distributionId, rootStore.distributionStore, publishNotification, rootStore.gameVersionStore.currentGameVersion, rootStore.gameEnvironmentsStore.currentGameEnvironment]);

    return result;
};
